import {
  BRANCH_STATUS_REQUEST,
  BRANCH_STATUS_SUCCESS,
  BRANCH_STATUS_FAILURE,
} from "../../actions/types";

// reducer.js
const initialState = {
  isLoading: false,
  response: null,
  error: null,
};

export const branchStatusReducer = (state = initialState, action) => {
  switch (action.type) {
    case BRANCH_STATUS_REQUEST:
      return { ...state, isLoading: true, response: null, error: null };
    case BRANCH_STATUS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        response: action.payload,
        error: null,
      };
    case BRANCH_STATUS_FAILURE:
      return {
        ...state,
        isLoading: false,
        response: null,
        error: action.payload,
      };
    default:
      return state;
  }
};
